import { render, staticRenderFns } from "./enCourseAssign.vue?vue&type=template&id=2f021f96&scoped=true&"
import script from "./enCourseAssign.vue?vue&type=script&lang=js&"
export * from "./enCourseAssign.vue?vue&type=script&lang=js&"
import style0 from "./enCourseAssign.vue?vue&type=style&index=0&id=2f021f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f021f96",
  null
  
)

export default component.exports